import { useQuery } from "@tanstack/react-query";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

const DEMO_PACKAGE_DETAIL = {
  packageId: 'demo-1',
  packageName: 'Demo Virtual Escape Adventure',
  imageSrc: 'https://images.pexels.com/photos/208701/pexels-photo-208701.jpeg',
  duration: '3 Nights / 4 Days',
  price: '108915.2',
  currency: 'INR',
  travelType: "Family",
  description: "Explore the glittering cityscape...",
  includes: "Stay at JW Marriott, Safari, Transfers"
};

export const usePackageDetails = (packageId, mode) => {
  return useQuery({
    queryKey: ["package-details", packageId],
    queryFn: async () => {
      // 1. Check if the ID literally starts with "demo-"
      // This means the grid returned our demo data fallback above
      if (String(packageId).startsWith('demo')) {
          return DEMO_PACKAGE_DETAIL;
      }

      // 2. Fetch the REAL package details from the DB using your actual ID!
      const response = await apiService.get(`${config.GETPACKAGEDETAILS}/${packageId}`);
      console.log("API Response for Package Details:", response);
      // Returns your real JSON object!
      return response.data || response;
    },
    enabled: !!packageId, 
  });
};